import { Dialog, DialogContent, DialogHeader, DialogTitle } from "components/ui/dialog";
import { Button } from "components/ui/button_v2";
import { APP_VERSION } from "../../services/constants";
import { useThemeStore } from "../../context/useThemeStore"


export default function WhatsNewModal({ open, onClose }) {

  const { theme, setTheme } = useThemeStore();

  const select_bg = theme === "dark" ? "bg-[#121928] text-white" : "bg-white text-foreground"
  const select_bg2 = theme === "dark" ? " text-white" : "text-foreground"

  return (
    <Dialog open={open} onOpenChange={onClose} className={select_bg}>
      <DialogContent className={"max-w-lg "+select_bg}>
        <DialogHeader>
          <DialogTitle className={"text-center text-2xl font-bold "+select_bg2}>
              What’s New in Eduprompt v{APP_VERSION}
          </DialogTitle>
        </DialogHeader>

        <div className="mt-4 space-y-3">
          {/* Banner */}
          <div className="rounded-xl bg-primary text-white p-4 text-center font-semibold">
            Major Improvements & New Features
          </div>

          <ul className="list-disc pl-6 space-y-2 text-sm">
            <li>New dashboard UI</li>
            <li>Add new Onboarding UI</li>
            <li>Bug Fixes and Improvements</li>
          </ul>
        </div>

        <div className="flex justify-center mt-6">
          <Button onClick={onClose}>Close</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
